/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmFineTuningListCheckpoints } from "../../funcs/llmFineTuningListCheckpoints.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListFineTuningCheckpointsRequest$inboundSchema,
};

export const tool$llmFineTuningListCheckpoints: ToolDefinition<typeof args> = {
  name: "llm-fine-tuning-list-checkpoints",
  description: `List fine-tuning checkpoints

List checkpoints for a fine-tuning job.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmFineTuningListCheckpoints(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
